import React from "react";
import { Filter } from "../styled.component";
import Buttons from "Components/Buttons";
import toast from "react-hot-toast";
import { Parameters, Values } from "Interfaces/IParameters";
import MultiSelect from "Components/MultiSelect";
import { Container } from "../styled.component";
import { useSelector } from "react-redux";

const FilterComponent = ({
  filterName,
  parameters,
  setValues,
  type,
  filterValues,
  handleViewReport,
}: {
  filterName: string;
  parameters: Array<Parameters>;
  setValues: (values: any) => void;
  type: string;
  filterValues?: any;
  handleViewReport: (_p: string) => void;
}) => {
  const [indexActive, setIndexActive] = React.useState<number | null>(null);
  const { filterThema } = useSelector((state: any) => state.theme);

  // Asegurar que filterValues siempre sea un objeto
  const safeFilterValues = filterValues || {};

  const renderOptions = (values: Array<Values>) => {
    if (values)
      return [
        {
          label: "Selecciona una opción",
          value: "",
        },
        ...values,
      ].map((item: Values) => (
        <option value={item.value}> {item.label}</option>
      ));
    return null;
  };

  const handleOnChage = (
    e: React.ChangeEvent<HTMLInputElement>,
    stateName: string
  ) => {
    if (e.target.value) {
      try {
        let local_p: Parameters | undefined | null = parameters.find(
          (item: Parameters) => item.codigoParametro === stateName
        );

        if (!local_p) return false;
        let find: Values | undefined | null = local_p.values.find(
          (item: Values) => item.value == e.target.value
        );

        setValues({ ...filterValues, [stateName]: find });
      } catch (err) {
        console.log(err);
      }
    }
  };

  const buildValues = (
    getFiltersByParam: Array<any>,
    index: number,
    aNextFilter: Array<any>,
    aApplyFilter: Array<any>,
    oNewFilter: Object
  ) => {
    let nextApply: Array<any> = [];
    for (let j = 0; j <= getFiltersByParam.length; j++) {
      let _localNextIndex: number = index + 1;

      if (parameters[_localNextIndex]?.values) {
        for (
          let index = 0;
          index < parameters[_localNextIndex].values.length;
          index++
        ) {
          if (
            parameters[_localNextIndex].values[index].value_ant ===
            getFiltersByParam[j].value
          ) {
            let _localValue = parameters[_localNextIndex].values[index];
            nextApply.push(_localValue);
          }
        }
      }

      aApplyFilter.push({
        label: getFiltersByParam[j].label,
        value: getFiltersByParam[j].value,
      });

      let limit = getFiltersByParam.length - 1;
      if (j === limit) {
        oNewFilter = {
          ...oNewFilter,
          [parameters[index]?.codigoParametro]: aApplyFilter,
        };
        break;
      }
    }
    getFiltersByParam = nextApply;
    nextApply = [];
    return { getFiltersByParam, oNewFilter };
  };

  const reorderFilters = (
    filters: any,
    isBuilding: boolean,
    parameter: Parameters
  ) => {
    if (filters) {
      let oNewFilter = { ...filters };
      let aProperties = [];

      //building arrray of properties
      for (const property of parameters) {
        aProperties.push(property.codigoParametro);
      }

      //validate if is building if other case this method will clean the filters
      if (isBuilding) {
        let getIndex: any = "";

        //get index to modify
        for (let index = 0; index < aProperties.length; index++) {
          let nResults = filters[aProperties[index]]?.length;
          if (
            nResults > 0 &&
            getIndex === "" &&
            aProperties[index] === parameter.codigoParametro
          ) {
            getIndex = index;
          }
        }

        let filterName: string = parameters[getIndex]?.codigoParametro || "";
        let getFiltersByParam = filters[filterName];
        let aNextFilter: Array<any> = [];

        for (let index = getIndex; index < parameters.length; index++) {
          if (getFiltersByParam?.length > 0) {
            let aApplyFilter: Array<any> = [];
            let result = buildValues(
              getFiltersByParam,
              index,
              aNextFilter,
              aApplyFilter,
              oNewFilter
            );
            getFiltersByParam = result?.getFiltersByParam;
            //@ts-ignore
            let res = result.oNewFilter[parameters[index].codigoParametro];
            oNewFilter = {
              ...oNewFilter,
              [parameters[index].codigoParametro]: res,
            };
          }
        }
      } else {
        let getIndex: any = "";

        //get index to modify
        for (let index = 0; index < aProperties.length; index++) {
          let nResults = filters[aProperties[index]]?.length;
          if (nResults === 0 && getIndex === "") {
            getIndex = index;
          }
        }

        for (
          let index = getIndex;
          index <= Object.keys(parameters).length;
          index++
        ) {
          //find next property if had value ant
          let findNextProperty = parameters[getIndex + 1]?.values.find(
            (item) => item.value_ant !== "" && item.value_ant !== null
          );
          if (findNextProperty) {
            oNewFilter = {
              ...oNewFilter,
              [parameters[index]?.codigoParametro]: [],
            };
          }
        }
      }
      setValues({ ...filterValues, ...oNewFilter });
    }
  };

  const checkedFilters = (
    isCheked: boolean,
    value: any,
    label: string,
    parameter: Parameters,
    type?: string
  ) => {
    let newFilter: object = { ...filterValues };
    //value for compare the next levels of filters
    let compareValue = value;
    let findIndex = parameters.findIndex(
      (oParameter) => oParameter.codigoParametro === parameter.codigoParametro
    );

    if (isCheked) {
      if (parameter.codigoParametroSig !== "") {
        if (type === "ComboSencillo") {
          //@ts-ignore
          newFilter[parameter.codigoParametroSig] = [];
        }
        for (let index = findIndex; index < parameters.length; index++) {
          //get default values for the next level
          let nextFilter = parameters[index + 1]?.values.filter(
            (item) => item.value_ant === compareValue
          );

          if (nextFilter?.length > 0) {
            let aTempFilter = [];

            let paramName = parameters[index + 1]?.codigoParametro;

            //get values by codigoParametro
            let findFilter = filterValues[paramName]
              ? filterValues[paramName]
              : [];

            compareValue = nextFilter[0]?.value;

            //build arr to filters
            let aApplyFilter = nextFilter.map((filter) => ({
              value: filter.value,
              label: filter.label,
            }));

            aTempFilter = [...findFilter, ...aApplyFilter];

            newFilter = {
              ...newFilter,
              [parameters[index + 1].codigoParametro]: aTempFilter,
            };
          }
        }
      }

      let _oldsValue = filterValues[parameter.codigoParametro]
        ? filterValues[parameter.codigoParametro]
        : [];

      if (type === "ComboSencillo") {
        setValues({
          ...filterValues,
          ...newFilter,
          [parameter.codigoParametro]: { value, label },
        });
      } else {
        setValues({
          ...filterValues,
          ...newFilter,
          [parameter.codigoParametro]: [..._oldsValue, { value, label }],
        });
      }
    } else {
      if (type === "ComboSencillo") {
        //@ts-ignore
        newFilter[parameter.codigoParametroSig] = [];
        if (value === "") {
          //@ts-ignore
          newFilter[parameter.codigoParametro] = {};
        }
      }
      if (parameter.codigoParametroSig !== "") {
        for (let index = findIndex; index < parameters.length; index++) {
          let nextFilter = parameters[index + 1]?.values.filter(
            (item) => item.value_ant === compareValue
          );

          if (nextFilter?.length > 0) {
            let aIndex: Array<number> = [];
            let paramName = parameters[index + 1]?.codigoParametro;
            //get current values in filters form
            let findFilter = filterValues[paramName]
              ? filterValues[paramName]
              : [];

            //get array of index to be removed from original array
            for (const item of nextFilter) {
              let _findIndex = findFilter.findIndex(
                (oFilter: any) => oFilter.value === item.value
              );
              aIndex.push(_findIndex);
            }

            //remove items
            findFilter = findFilter.filter((value: any, nIndex: number) => {
              return aIndex.indexOf(nIndex) == -1;
            });

            compareValue = nextFilter[0]?.value;

            newFilter = {
              ...newFilter,
              [parameters[index + 1].codigoParametro]: findFilter,
            };
          }
        }
      }

      let _localObject = Object.assign({}, filterValues);
      let _olds = _localObject[parameter.codigoParametro];

      if (type === "ComboSencillo") {
        setValues({
          ...filterValues,
          ...newFilter,
        });
      } else {
        //get index to remove of original arr
        let _filter = _olds.filter((_find: Values) => _find.value !== value);
        setValues({
          ...filterValues,
          ...newFilter,
          [parameter.codigoParametro]: [..._filter],
        });
      }
    }
  };

  const renderInput = (parameter: Parameters, index: number) => {
    //se encarga de buscar posibles opciones dependiendo de anterioro si no depende del anterior
    let _options: Array<Values> | null = parameter.codigoParametroAnt
      ? parameter.values.filter((v: Values) => v.label && v.label).filter((_filter: Values) => {
        if (filterValues[parameter.codigoParametroAnt]) {
          if (
            filterValues[parameter.codigoParametroAnt].constructor === Array
          ) {
            let _find = filterValues[parameter.codigoParametroAnt].find(
              (_select: Values) =>
                _select.value?.toString() === _filter.value_ant?.toString()
            );
            if (_find) return _filter;
          }

          if (
            filterValues[parameter.codigoParametroAnt].constructor === Object
          ) {
            let _find =
              filterValues[parameter.codigoParametroAnt].value?.toString() ===
              _filter.value_ant?.toString();
            if (_find) return _filter;
          }
        }

        return null;
      })
      : parameter.values.filter((v: Values) => v.label && v.label);

    switch (parameter.tipoParametro) {
      case "Fecha":
        return (
          <input
            type="date"
            defaultValue={
              filterValues[parameter.codigoParametro]
                ? filterValues[parameter.codigoParametro]
                : null
            }
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setValues({
                ...filterValues,
                [parameter.codigoParametro]: e.target.value,
              })
            }
          />
        );
      case "ComboSencillo": {
        return (
          <select
            value={
              filterValues[parameter.codigoParametro]
                ? filterValues[parameter.codigoParametro].value
                : null
            }
            //@ts-ignore
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              //handleOnChage(e, parameter.codigoParametro);
              const oSelectValue = parameter.values.find(
                (item) => item.value === e.target.value
              );
              console.log(oSelectValue, e.target.value);

              checkedFilters(
                e.target.value !== "" ? true : false,
                e.target.value,
                oSelectValue?.label ?? "",
                parameter,
                "ComboSencillo"
              );
            }}
          >
            {renderOptions(_options)}
          </select>
        );
      }
      case "Combo": {
        return (
          <MultiSelect
            title={"Selecciona una o mas opciónes"}
            //@ts-ignore
            setIndexActive={setIndexActive}
            indexActive={indexActive}
            currentIndex={index}
            options={_options || []}
            selected={
              filterValues[parameter.codigoParametro]
                ? filterValues[parameter.codigoParametro]
                : []
            }
            onChange={({
              checked,
              value,
              label,
            }: {
              checked: boolean;
              value: string;
              label: string;
            }) => {
              if (value === "All") {
                let select_all = _options ? _options : [];
                let oValues = {
                  ...filterValues,
                  [parameter.codigoParametro]: checked ? [...select_all] : [],
                };
                reorderFilters(oValues, checked, parameter);
                return true;
              }
              if (value) {
                checkedFilters(checked, value, label, parameter);
                return true;
              }
            }}
          />
        );
      }
    }
    return null;
  };

  const renderFilter = () => {
    return parameters
      .filter((item: Parameters) => item.visible)
      .map((item: Parameters, index: number) => (
        <div className="item-input">
          <div className="item-control">
            <label> {item.nombreParametro}</label>
          </div>
          <div>{renderInput(item, index)}</div>
        </div>
      ));
  };
  return (
    <Filter bgHeader={filterThema?.bgHeader || "#3c3b398c"}>
      <div className="title">
        <span>Filtros de reportes {filterName}</span>
      </div>
      <Container>{renderFilter()}</Container>
      <div className="footer">
        <Buttons
          type="secondary"
          title="Ver reporte"
          height={40}
          width={150}
          config={{
            background: filterThema?.btnColor || "#5c5c5c",
          }}
          handleClick={() => {
            //validar todos los filtros

            //se recolectan los nombres de los parametros a enviar :()
            //esto sirvira para revisar que no se escape ninguno de los que regresa bd
            let _myFilterAllNames = parameters
              .filter((_item: Parameters) => _item.visible)
              .map((_parameter: Parameters) => ({
                codigoParametro: _parameter.codigoParametro,
                nombreParametro: _parameter.nombreParametro,
              }));

            console.log(filterValues);
            console.log(_myFilterAllNames);
            //validando filtros existentes
            if (
              Object.keys(filterValues).length === 0 &&
              _myFilterAllNames.length
            ) {
              toast.error("No hay valores seleccionados", {
                style: {
                  padding: "16px",
                  color: "#000",
                  fontFamily: "MontserratRegular",
                },
              });
              return false; //😡
            }

            let parameters_url: string = "";
            //se recorre el array y se revisara uno a uno si existe el valor
            for (let _name of _myFilterAllNames) {
              //se busca el nombre en el banco de filtros seleccionados
              const filterValue = filterValues[_name.codigoParametro];
              
              // Validar que el filtro tenga un valor
              let hasValue = false;
              
              if (filterValue === undefined || filterValue === null) {
                hasValue = false;
              } else if (typeof filterValue === "string") {
                // Para tipo Fecha
                hasValue = filterValue.trim() !== "";
              } else if (Array.isArray(filterValue)) {
                // Para tipo Combo
                hasValue = filterValue.length > 0;
              } else if (typeof filterValue === "object") {
                // Para tipo ComboSencillo
                hasValue = Object.keys(filterValue).length > 0 && filterValue.value !== "" && filterValue.value !== undefined;
              }
              
              if (!hasValue) {
                toast.error(
                  `El filtro ${_name.nombreParametro} no tienen valores seleccionados`,
                  {
                    style: {
                      padding: "16px",
                      color: "#000",
                      fontFamily: "MontserratRegular",
                    },
                  }
                );
                return false;
              }
              //se formara los datos a enviar al servicio que representara al reporte
              //se revisara si es string

              if (typeof filterValues[_name.codigoParametro] === "string") {
                if (type === "PowerBI") {
                  parameters_url += `${_name.codigoParametro} in ( '${
                    filterValues[_name.codigoParametro]
                  }' ) and `;
                } else {
                  parameters_url += `${_name.codigoParametro}=${
                    filterValues[_name.codigoParametro]
                  }&`;
                }

                continue;
              } else if (
                Array.isArray(filterValues[_name.codigoParametro])
              ) {
                if (type === "PowerBI") {
                  let _valuesJoin = filterValues[_name.codigoParametro].map(
                    (_frmValues: Values) => {
                      if (+_frmValues.value) {
                        return _frmValues.value;
                      } else {
                        return `'${_frmValues.value}'`;
                      }
                    }
                  );

                  parameters_url += `${
                    _name.codigoParametro
                  } in (${_valuesJoin.join(",")}) and `;
                } else {
                  let _valuesJoin = filterValues[_name.codigoParametro]
                    .map((_frmValues: Values) => _frmValues.value)
                    .join(",");

                  parameters_url += `${_name.codigoParametro}=${_valuesJoin}&`;
                }

                continue;
              } else if (typeof filterValues[_name.codigoParametro] === "object") {
                // Para tipo ComboSencillo (objeto)
                if (type === "PowerBI") {
                  let _value = +filterValues[_name.codigoParametro].value
                    ? filterValues[_name.codigoParametro].value
                    : `'${filterValues[_name.codigoParametro].value}'`;
                  parameters_url += `${_name.codigoParametro} in (${_value}) and `;
                } else {
                  parameters_url += `${_name.codigoParametro}=${
                    filterValues[_name.codigoParametro].value
                  }&`;
                }
                continue;
              }
            }

            let _filterNoVisibles = parameters.filter(
              (_item: Parameters) => !_item.visible
            );
            for (let key of _filterNoVisibles) {
              if (type === "PowerBI") {
                let _val = key.values.map((val: Values) => val.value);
                parameters_url += `${key.codigoParametro} in (${_val.join(
                  ","
                )}) and `;
              } else {
                let _val = key.values.map((val: Values) => val.value);
                parameters_url += `${key.codigoParametro}=${_val.join(",")}&`;
              }
            }

            handleViewReport && handleViewReport(parameters_url);
            //setValues && setValues(parameters_url)
          }}
        />
      </div>
    </Filter>
  );
};

export default FilterComponent;
